import React, { useState } from "react";
const iPhoneHero = "https://d1vqw4it8x9uac.cloudfront.net/admin/body-1790589733.png";
const iPhoneHero1 = "https://d1vqw4it8x9uac.cloudfront.net/admin/body-1-1790589733.png";
function RevampHeroProfessionals() {
  const [heroMode, setHeroMode] = useState("without");
  const heroImage = heroMode === "with" ? iPhoneHero1 : iPhoneHero;

  return (
    <section className="revamp-hero-wrap revamp-hero-pro-wrap" aria-label="Professionals hero">
      <section className="revamp-hero revamp-hero-pro">
        <div className="revamp-hero-inner">
          <div className="revamp-hero-split">
            <div className="revamp-hero-left-pro">
              <div className="revamp-hero-eyebrow revamp-pro-hero-eyebrow">
                <span className="revamp-hero-eyebrow-muted">India&apos;s</span>
                <span className="revamp-hero-eyebrow-accent">Home App</span>
              </div>

              <h1 className="revamp-hero-heading">
                Stop sending clients to 5 
                <br />
                different places.
                <br />
                <span className="revamp-hero-heading-accent">HYNT brings it all</span>
                <br />
                <span className="revamp-hero-heading-accent">together.</span>
              </h1>

              <p className="revamp-hero-subcopy revamp-hero-pro-subcopy">
                Showcase your work, receive inquiries, discover brands &amp; products, and grow your
                business — all in one place.
              </p>
            </div>

            <div className="revamp-hero-right" aria-hidden="true">
              <div className="revamp-hero-phone-stage revamp-hero-pro-stage">
                <div className="revamp-hero-pro-toggle" role="tablist" aria-label="HYNT comparison">
                  <button
                    type="button"
                    className={`revamp-hero-pro-pill ${heroMode === "without" ? "is-active" : ""}`.trim()}
                    role="tab"
                    aria-selected={heroMode === "without"}
                    onClick={() => setHeroMode("without")}
                  >
                    Without HYNT
                  </button>
                  <button
                    type="button"
                    className={`revamp-hero-pro-pill ${heroMode === "with" ? "is-active" : ""}`.trim()}
                    role="tab"
                    aria-selected={heroMode === "with"}
                    onClick={() => setHeroMode("with")}
                  >
                    With HYNT
                  </button>
                </div>
                <img className="revamp-hero-phone" src={heroImage} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
}

export default RevampHeroProfessionals;

